import { IsBoolean, IsString } from "class-validator";

export class TemplateInformationFieldDto {
  @IsBoolean()
  required!: boolean;

  @IsString()
  type!: string;

  @IsBoolean()
  visible!: boolean;
}
